import { call, put } from "redux-saga/effects";
import { apiGeneral, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { ListPlantActions } from "store/ducks/settings/plant";
import { IPlant } from "interfaces/plant";

export function* listPlantRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(apiGeneral.get, `/plants?${queryString}`);

    let comboOptions = [];
    if (data.types && data.types.length > 0) {
      comboOptions = data.types.map((plant: IPlant) => ({
        value: plant.id,
        label: plant.name,
      }));
    } else if (data.length > 0) {
      comboOptions = data.map((plant: IPlant) => ({
        value: plant.id,
        label: plant.name,
      }));
    }
    yield put(ListPlantActions.success(comboOptions));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListPlantActions.failure(errorMessage));
  }
}
